<template>
    <div class="page-shell min-h-screen">
        <p class="mobile-page-title font-helvetica-700 font-bold text-gray-dark lg:text-[40px] lg:uppercase">
            Профиль
        </p>

        <div class="flex flex-col flex-1">
            <SettingsNavBar />

            <!-- Обёртка -->
            <div class="relative flex-1">
                <!-- ФОН -->
                <div class="absolute inset-0 bg-no-repeat bg-top bg-contain"
                    style="background-image: url('/traktor.svg')"></div>
                <!-- OVERLAY -->
                <div class="absolute inset-0 bg-white opacity-90"></div>

                <!-- КОНТЕНТ -->
                <div class="relative z-10 flex h-full items-center justify-center p-5 xl:p-10 2xl:p-20">
                    <div class="flex w-full max-w-[480px] flex-col gap-3.5 rounded-[20px] bg-white-gray px-5 py-7.5">
                        <SettingsInput
                            v-model="form.current"
                            label="Текущий пароль"
                            placeholder="Введите текущий пароль"
                            type="password"
                        />
                        <SettingsInput
                            v-model="form.next"
                            label="Новый пароль"
                            placeholder="Укажите новый пароль"
                            type="password"
                            :error="newPasswordError"
                        />
                        <SettingsInput
                            v-model="form.confirm"
                            label="Подтверждение"
                            placeholder="Подтвердите новый пароль"
                            type="password"
                            :error="confirmPasswordError"
                        />
                        <button
                            :disabled="isSubmitDisabled"
                            class="bg-orange text-[16px] font-helvetica-700 font-bold text-white py-3 rounded-[10px] disabled:opacity-60 disabled:cursor-not-allowed"
                            @click="submitChange"
                        >
                            {{ buttonLabel }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>





<script lang="ts" setup>
import SettingsNavBar from "~/components/settings/SettingsNavBar.vue";
import SettingsInput from "~/components/settings/SettingsInput.vue";
import { computed, reactive, ref } from "vue";
import { useNuxtApp } from "#imports";

usePageTitle("Профиль: смена пароля");

const form = reactive({
    current: "",
    next: "",
    confirm: "",
});

const isSubmitting = ref(false);
const isSuccess = ref(false);
const minPasswordLength = 6;

const nuxtApp = useNuxtApp();
const $useOneCApi = nuxtApp.$useOneCApi as (action: string, payload?: Record<string, any>) => Promise<any>;

const isFormValid = computed(
    () =>
        !!form.current &&
        form.next.length >= minPasswordLength &&
        form.confirm.length >= minPasswordLength &&
        form.next === form.confirm
);

const passwordMismatch = computed(
    () => !!form.next && !!form.confirm && form.next !== form.confirm
);

const newPasswordError = computed(() =>
    form.next && form.next.length < minPasswordLength
        ? `Минимум ${minPasswordLength} символов`
        : ""
);

const confirmPasswordError = computed(() => {
    if (form.confirm && form.confirm.length < minPasswordLength) {
        return `Минимум ${minPasswordLength} символов`;
    }
    if (passwordMismatch.value) {
        return "Пароли не совпадают";
    }
    return "";
});

const isSubmitDisabled = computed(
    () => isSubmitting.value || isSuccess.value || !isFormValid.value
);

const buttonLabel = computed(() =>
    isSuccess.value ? "Пароль успешно изменен" : "Сменить пароль"
);

const submitChange = async () => {
    if (isSubmitDisabled.value) return;
    if (!isFormValid.value) return;
    isSubmitting.value = true;
    try {
        await $useOneCApi("setPassword", {
            old: form.current,
            new: form.next,
        });
        isSuccess.value = true;
    } catch (error) {
        console.error("Не удалось сменить пароль", error);
    } finally {
        isSubmitting.value = false;
    }
};
</script>
